<template>
	<div class="app-container">
		<el-row :gutter="20">
			<el-col :xs="24" :md="12" :lg="6" class="pb-10">
				<el-card shadow="hover">
					<div class="data-item">
						<div class="data-icon">
							<el-icon>
								<User />
							</el-icon>
						</div>
						<div class="data-info">
							<div class="data-title">总客户数</div>
							<div class="data-value">{{ statistics.customer }}</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :xs="24" :md="12" :lg="6" class="pb-10">
				<el-card shadow="hover">
					<div class="data-item">
						<div class="data-icon">
							<el-icon>
								<Calendar />
							</el-icon>
						</div>
						<div class="data-info">
							<div class="data-title">月回款额</div>
							<div class="data-value text-price">{{ formatAmount(statistics.mon) }}</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :xs="24" :md="12" :lg="6" class="pb-10">
				<el-card shadow="hover">
					<div class="data-item">
						<div class="data-icon">
							<el-icon>
								<Money />
							</el-icon>
						</div>
						<div class="data-info">
							<div class="data-title">总回款额</div>
							<div class="data-value text-price">{{ formatAmount(statistics.recTol) }}</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :xs="24" :md="12" :lg="6" class="pb-10">
				<el-card shadow="hover">
					<div class="data-item">
						<div class="data-icon">
							<el-icon>
								<Histogram />
							</el-icon>
						</div>
						<div class="data-info">
							<div class="data-title">转化率</div>
							<div class="data-value">{{ statistics.leads*100 }}%</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :md="24" :lg="12" class="pb-10">
				<el-card shadow="hover">
					<template #header>
						<div class="card-header">
							<span>销售趋势</span>
							<el-date-picker v-model="currentYear" @change="handleYearChange" type="year"
								placeholder="选择年" />
						</div>
					</template>
					<div ref="salesChart" class="chart"></div>
				</el-card>
			</el-col>
			<el-col :md="24" :lg="12" class="pb-10">
				<el-card shadow="hover">
					<template #header>
						<div class="card-header">
							<span>客户增长趋势</span>
							<el-date-picker v-model="currentYear1" @change="handleYearChange1" type="year"
								placeholder="选择年" />
						</div>
					</template>
					<div ref="userChart" class="chart"></div>
				</el-card>
			</el-col>
			<el-col :md="24" :lg="12" class="pb-10">
				<el-card shadow="hover">
					<template #header>
						<div class="card-header">
							<span>最近商机</span>
						</div>
					</template>
					<el-table :data="recentOrders.business" style="width: 100%">
						<el-table-column prop="id" label="订单号" width="180"></el-table-column>
						<el-table-column prop="customerName" label="客户"></el-table-column>
						<el-table-column prop="expectedAmount" label="金额"></el-table-column>
						<el-table-column prop="stage" label="商机状态">
							<template #default="scope">
								<el-tag :type="getStatusType(scope.row.stage)">
									{{ getStatusText(scope.row.stage) }}
								</el-tag>
							</template>

						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
			<el-col :md="24" :lg="12" class="pb-10">
				<el-card shadow="hover">
					<template #header>
						<div class="card-header">
							<span>热门商品</span>
						</div>
					</template>
					<el-table :data="recentOrders.proList" style="width: 100%">
						<el-table-column prop="productName" label="商品名称"></el-table-column>
						<el-table-column prop="productNum" label="销量"></el-table-column>
						<el-table-column prop="productPrice" label="销售额"></el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import {
		getMainNum,
		getEcharts,
		getEchartsZhu,
		getMainList
	} from '@/api/dashboard'

	export default {
		name: 'DashboardView',
		data() {
			return {
				statistics: {
					customer: 0,
					mon: 0,
					recTol: 0,
					leads: 0
				},
				recentOrders: [],
				hotProducts: [],
				salesChartInstance: null,
				userChartInstance: null,
				currentYear: new Date(), // 当前年份
				currentYear1: new Date(), // 当前年份
				yearOptions: [], // 年份选项
				currentMonth: new Date().toISOString().slice(0, 7), // 当前月份，格式：YYYY-MM
				monthOptions: [] // 月份选项
			}
		},
		methods: {
			formatAmount(amount) {
				return amount ? amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2
				}) : '0.00'
			},
			getStatusType(status) {
				const statusMap = {
					0: 'info',
					1: 'warning',
					2: 'primary',
					3: 'success',
					4: 'success',
					5: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '初步接触',
					1: '需求确认',
					2: '方案报价',
					3: '商务谈判',
					4: '赢单',
					5: '输单'
				}
				return statusMap[status] || status
			},
			// 生成年份选项
			generateYearOptions() {
				const options = []
				const currentYear = new Date().getFullYear() + "-01-01"

				// 生成最近5年的选项
				for (let i = 0; i < 5; i++) {
					const year = currentYear - i
					options.push({
						value: year.toString(),
						label: `${year}年`
					})
				}
				this.yearOptions = options
			},


			// 生成年份的月份数据
			generateYearMonthData(year) {
				const months = []
				for (let month = 1; month <= 12; month++) {
					months.push({
						time: `${year}-${month.toString().padStart(2, '0')}`,
						price: 0
					})
				}
				return months
			},

			// 补全数据
			completeData(data, yearData) {
				const dataMap = new Map(data.map(item => [item.time, item.price]))
				return yearData.map(item => ({
					time: item.time,
					price: dataMap.get(item.time) || 0
				}))
			},

			// 处理年份变化
			async handleYearChange(year) {
				console.log(year)
				this.currentYear = year
				const res = await getEcharts({
					time: year.getFullYear() + "-01-01"
				})
				this.echartsData = res.data
				this.initSalesChart(this.echartsData.lines)
				this.initUserChart(this.echartsData.zhu)
			},

			// 处理年份变化
			async handleYearChange1(year) {
				console.log(year)
				this.currentYear1 = year
				const res = await getEchartsZhu({
					time: year.getFullYear() + "-01-01"
				})
				this.echartsZhuData = res.data
				this.initUserChart(this.echartsZhuData.zhu)
			},

			// 生成月份选项
			generateMonthOptions() {
				const options = []
				const currentDate = new Date()
				const currentYear = currentDate.getFullYear()
				const currentMonth = currentDate.getMonth()

				// 生成最近12个月的选项
				for (let i = 0; i < 12; i++) {
					const date = new Date(currentYear, currentMonth - i, 1)
					const year = date.getFullYear()
					const month = date.getMonth() + 1
					const value = `${year}-${month.toString().padStart(2, '0')}`
					const label = `${year}年${month}月`
					options.push({
						value,
						label
					})
				}
				this.monthOptions = options
			},

			// 生成连续的日期数组
			generateDateRange(startDate, endDate) {
				const dates = []
				const currentDate = new Date(startDate)
				const lastDate = new Date(endDate)

				while (currentDate <= lastDate) {
					dates.push(currentDate.toISOString().split('T')[0])
					currentDate.setDate(currentDate.getDate() + 1)
				}
				return dates
			},

			// 生成月份日期范围
			generateMonthDateRange(monthStr) {
				const [year, month] = monthStr.split('-')
				const startDate = new Date(year, month - 1, 1)
				const endDate = new Date(year, month, 0) // 获取月份的最后一天
				return this.generateDateRange(startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
			},

			// 处理月份变化
			async handleMonthChange(month) {
				console.log(month);

				this.currentMonth = month
				const res = await getEcharts({
					time: month
				})
				this.echartsData = res.data
				this.initSalesChart(this.echartsData.lines)
				this.initUserChart(this.echartsData.zhu)
			},

			initSalesChart(data) {
				if (!this.$refs.salesChart) return

				// 生成年份的月份数据
				const yearData = this.generateYearMonthData(this.currentYear.getFullYear())

				// 补全数据
				const completeData = this.completeData(data, yearData)

				let time = []
				let price = []
				completeData.forEach(item => {
					time.push(item.time)
					price.push(item.price)
				})

				this.salesChartInstance = echarts.init(this.$refs.salesChart)
				const option = {
					title: {
						text: '销售趋势'
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						data: time,
						axisLabel: {
							rotate: 45,
							formatter: (value) => {
								return value.split('-')[1] + '月'
							}
						}
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '销售额',
						type: 'line',
						smooth: true,
						data: price
					}]
				}
				this.salesChartInstance.setOption(option)
			},

			initUserChart(data) {
				if (!this.$refs.userChart) return

				// 生成年份的月份数据
				const yearData = this.generateYearMonthData(this.currentYear.getFullYear())

				// 补全数据
				const completeData = this.completeData(data, yearData)

				let time = []
				let price = []
				completeData.forEach(item => {
					time.push(item.time)
					price.push(item.price)
				})

				this.userChartInstance = echarts.init(this.$refs.userChart)
				const option = {
					title: {
						text: '客户增长趋势'
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						data: time,
						axisLabel: {
							rotate: 45,
							formatter: (value) => {
								return value.split('-')[1] + '月'
							}
						}
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '客户数',
						type: 'bar',
						data: price
					}]
				}
				this.userChartInstance.setOption(option)
			},

			async fetchData() {
				try {
					const res = await getMainNum()
					console.log(res)
					this.statistics = res.data

					const res2 = await getMainList()
					this.recentOrders = res2.data
					console.log(res2)
					// 这里添加实际的数据获取逻辑
					// this.statistics = {
					//   totalUsers: 1234,
					//   totalOrders: 5678,
					//   totalSales: 99999,
					//   conversionRate: 15.8
					// }

					// this.recentOrders = [
					//   { id: '001', customer: '张三', amount: '¥1000', status: '已完成' },
					//   { id: '002', customer: '李四', amount: '¥2000', status: '处理中' }
					// ]

					this.hotProducts = [{
							name: '商品A',
							sales: 100,
							amount: '¥10000'
						},
						{
							name: '商品B',
							sales: 80,
							amount: '¥8000'
						}
					]
				} catch (error) {
					console.error('获取数据失败:', error)
				}
			},
			handleResize() {
				this.salesChartInstance?.resize()
				this.userChartInstance?.resize()
			}
		},
		async mounted() {
			const res = await getEcharts({
				time: new Date().getFullYear().toString() + "-01-01"
			})
			console.log(res)
			const res2 = await getEchartsZhu({
				time: new Date().getFullYear().toString() + "-01-01"
			})
			console.log(res2)
			this.echartsData = res.data
			this.echartsZhuData = res2.data
			this.initSalesChart(this.echartsData.lines)
			this.initUserChart(this.echartsZhuData.zhu)
			this.fetchData()
			this.generateMonthOptions()
			this.generateYearOptions()
			window.addEventListener('resize', this.handleResize)
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.handleResize)
			this.salesChartInstance?.dispose()
			this.userChartInstance?.dispose()
		}
	}
</script>

<style scoped>
	.mt-20 {
		margin-top: 10px;
	}

	.pb-10 {
		padding-bottom: 20px;
	}

	.data-item {
		display: flex;
		align-items: center;
		padding: 0 20px;
	}

	.data-icon {
		font-size: 48px;
		margin-right: 20px;
		color: #409EFF;
	}

	.data-info {
		flex: 1;
		text-align: right;
	}

	.data-title {
		font-size: 14px;
		color: #909399;
	}

	.data-value {
		font-size: 24px;
		font-weight: bold;
		color: #303133;
		margin-top: 5px;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.chart {
		height: 400px;
	}

	@media screen and (max-width: 768px) {
		.chart {
			height: 300px;
		}
	}
</style>